import { handleApiCall, handleApiCallV2, apiCall } from "./Interactor"


export const createVenue = (formData, onSuccessView, onFailedView) => {


  handleApiCall(
    "POST",
    process.env.REACT_APP_COURT + "/create_new", formData,
    (responseJSON) => {
    },
    onSuccessView,
    onFailedView
  )

}


export const editVenue = (venueId, formData, onSuccessView, onFailedView) => {


  handleApiCall(
    "PUT",
    process.env.REACT_APP_COURT + "/" + venueId, formData,
    (responseJSON) => {
    },
    onSuccessView,
    onFailedView
  )

}


export const getVenueDetail = (venueId, onSuccessView, onFailedView) => {

  handleApiCall(
    "GET",
    process.env.REACT_APP_COURT + "/" + venueId, {},
    (responseJSON) => {
    },
    onSuccessView,
    onFailedView
  )

}

export const getListService = (page, onSuccessView, onFailedView) => {
  // https://staging.walletkuportal.com:1998/api/v3/services/?auth_token=x-yFPT_sQw2FQDqv3Abu
  // var authToken = process.env.REACT_APP_AUTH_TOKEN;
  handleApiCall(
    "GET",
    process.env.REACT_APP_COURT + "?page=" + page, {},
    (responseJSON) => {

    },
    onSuccessView,
    onFailedView
  )

}

export const getVenueSchedule = (venueId, selectedDate, onSuccessView, onFailedView) => {

  // const param = {
  //   "service_id": venueId,
  //   "date_available": selectedDate
  // }
  const getDayName = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('id-ID', { weekday: 'long' });
  };
  const dayName = getDayName(selectedDate);
  const param = {
    "service_id": venueId,
    "day": dayName,
    "date_available": selectedDate
  }

  handleApiCall(
    "POST",
    process.env.REACT_APP_VENUE_SCHEDULE_BY_DAY, param,
    (responseJSON) => {
      // console.log("result post schedule ", responseJSON)
    },
    onSuccessView,
    onFailedView
  )

}

export const getVenuePackages = (venueId, onSuccessView, onFailedView) => {

  const param = {
    "service_id": venueId
  }

  handleApiCall(
    "POST",
    process.env.REACT_APP_VENUE_PACKAGES, param,
    (responseJSON) => {
      // console.log("result post schedule ", responseJSON)
    },
    onSuccessView,
    onFailedView
  )

}

export const bookVenueByAdmin = (param, onSuccessView, onFailedView) => {

  handleApiCall(
    "POST",
    process.env.REACT_APP_VENUE_BOOKING_ADMIN, param,
    (responseJSON) => {
      console.log(" ", responseJSON)
    },
    onSuccessView,
    onFailedView
  )

}




export const getVenueScheduleClosed = (venueId, onSuccessView, onFailedView) => {
  handleApiCall(
    "POST",
    process.env.REACT_APP_COURT + "/" + venueId + "/list_schedule_closed", {},
    (responseJSON) => {
    },
    onSuccessView,
    onFailedView
  )
}


export const updateVenueScheduleClosed = (venueId, data, onSuccessView, onFailedView) => {
  handleApiCall(
    "PUT",
    process.env.REACT_APP_COURT + "/" + venueId + "/update_schedule_closed", data,
    (responseJSON) => {
    },
    onSuccessView,
    onFailedView
  )
}